<template lang="pug">
modal#delete-account-organizations-owner-modal.modal.fade(
  :close-button-label='$t("modal.deleteAccountOrganizationsModal.closeButtonLabel")'
  :disable-process-button='disableProcessButton'
  :loading='loading'
  :process-button-label='$t("modal.deleteAccountOrganizationsModal.processButtonLabel")'
  :remove-close-button='true'
  :title='$t("modal.deleteAccountOrganizationsModal.title")'
  @process='review'
  data-bs-backdrop='static'
  data-bs-keyboard='false'
  processButtonClass='btn-primary'
  ref='modal'
  size='lg'
)
  .text-center
    div
      p.text-start {{ $t('modal.deleteAccountOrganizationsModal.message') }}
      #delete-account-organizations-owner-accordion.mt-4.accordion(
        v-if='organizations.length'
      )
        .delete-account-organizations-owner-modal__list
          organization-owner-card(
            :index='index'
            :key='organization.id'
            :organization='organization'
            :selected-new-owner-id='getSelectedNewOwnerId(organization.id)'
            :value='getSelectedAction(organization.id)'
            @input='updateOrganizationAction(organization.id, $event)'
            @select-new-owner='updateOrganizationNewOwner(organization.id, $event)'
            @select-new-owner-review-data='updateReviewOwnerData(organization.id, $event)'
            v-for='(organization, index) in organizations'
          )
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';
import ImageLoader from '@/ui/molecules/ImageLoader.vue';
import OrganizationOwnerCard from '@/modules/account/components/molecules/OrganizationOwnerCard.vue';
import DeleteAccountReviewActionsOrganizationsOwnerModal from '@/modules/account/components/organisms/modals/DeleteAccountReviewActionsOrganizationsOwnerModal.vue';

export default {
  name: 'DeleteAccountOrganizationsOwnerModal',
  components: {
    DeleteAccountReviewActionsOrganizationsOwnerModal,
    OrganizationOwnerCard,
    Modal,
    Icon,
    ImageLoader,
  },
  props: {
    organizations: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      organizationDecisions: [],
      selectedOwnersReviewData: [],
      reviewItems: [],
    };
  },
  watch: {
    organizations: {
      immediate: true,
      handler() {
        this.organizationDecisions = this.organizations.map((organization) => ({
          organizationId: organization.id,
          action: '',
          newOwnerId: '',
        }));

        this.selectedOwnersReviewData = this.organizations.map(
          (organization) => ({
            organizationId: organization.id,
            userData: null,
          })
        );

        this.loading = false;
      },
    },
  },
  computed: {
    disableProcessButton() {
      if (!this.loading && !this.organizations.length) {
        return false;
      }
      if (!this.organizationDecisions.length) {
        return true;
      }
      return this.organizationDecisions.some((decision) => {
        if (decision.action === '') {
          return true;
        }
        if (decision.action === 'transfer' && !decision.newOwnerId) {
          return true;
        }
        return false;
      });
    },
  },
  methods: {
    review() {
      this.reviewItems = this.organizations.map((organization) => {
        const decision = this.getOrganizationDecision(organization.id);
        const selectedOwner = this.getSelectedOwnerReviewData(
          organization.id
        )?.userData;
        return {
          organizationId: organization.id,
          organizationName: organization.name,
          usersCount: organization.users_count,
          action: decision?.action || '',
          newOwnerId: decision?.newOwnerId || '',
          newOwnerName: selectedOwner?.name || '',
          newOwnerEmail: selectedOwner?.email || '',
        };
      });
      const emitData = {
        organizationDecisions: this.organizationDecisions,
        reviewItems: this.reviewItems,
      };
      this.$emit('review-actions-organizations-owner', emitData);
    },
    getOrganizationDecision(organizationId) {
      return this.organizationDecisions.find(
        (decision) => decision.organizationId === organizationId
      );
    },
    getSelectedAction(organizationId) {
      return this.getOrganizationDecision(organizationId)?.action || '';
    },
    getSelectedNewOwnerId(organizationId) {
      return this.getOrganizationDecision(organizationId)?.newOwnerId || '';
    },
    getSelectedOwnerReviewData(organizationId) {
      return this.selectedOwnersReviewData.find(
        (item) => item.organizationId === organizationId
      );
    },
    updateOrganizationAction(organizationId, action) {
      this.organizationDecisions = this.organizationDecisions.map(
        (decision) => {
          if (decision.organizationId !== organizationId) {
            return decision;
          }
          return {
            ...decision,
            action,
            newOwnerId: action === 'transfer' ? decision.newOwnerId : '',
          };
        }
      );
      if (action !== 'transfer') {
        this.updateReviewOwnerData(organizationId, null);
      }
    },
    updateOrganizationNewOwner(organizationId, newOwnerId) {
      this.organizationDecisions = this.organizationDecisions.map(
        (decision) => {
          if (decision.organizationId !== organizationId) {
            return decision;
          }
          if (decision.action !== 'transfer') {
            newOwnerId = '';
          }
          return {
            ...decision,
            newOwnerId,
          };
        }
      );
    },
    updateReviewOwnerData(organizationId, userData) {
      this.selectedOwnersReviewData = this.selectedOwnersReviewData.map(
        (item) => {
          if (item.organizationId !== organizationId) {
            return item;
          }
          return {
            ...item,
            userData,
          };
        }
      );
    },
  },
};
</script>
<style scoped>
.delete-account-organizations-owner-modal__list {
  max-height: calc(100vh - 420px);
  overflow-y: auto;
  padding-right: 8px;
}
</style>
